import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CommissionProgress, CommissionBadge } from "@/components/CommissionProgress";

export const CommissionCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/me/spending").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <Card className="mb-8 p-6" data-testid="commission-card">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-display text-lg font-bold text-slate-900">Commission progress</h3>
        <CommissionBadge s={s} testId="commission-badge" />
      </div>
      <CommissionProgress s={s} />
      <p className="mt-2 text-xs text-slate-400" data-testid="commission-total">Total spent: ${s.total_spent.toFixed(2)}</p>
    </Card>
  );
};
